import React from "react";

interface WarningProps {
    className?: string;
    fill?: string;
}

const Warning: React.FC<WarningProps> = ({ className, fill }) => {
    return (
        <svg className={className} viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg">
            <g id="color">
                <polygon
                    fill={fill || "#FCEA2B"}
                    stroke="none"
                    points="35.7297,13.6389 13.2216,56.3611 58.2378,56.3611"
                />
            </g>
            <g id="hair" />
            <g id="skin" />
            <g id="skin-shadow" />
            <g id="line">
                <polyline
                    fill="none"
                    stroke="#000000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                    points="35.7297,13.6389 13.2216,56.3611 58.2378,56.3611 35.7297,13.6389"
                />
                <line
                    x1="35.7297"
                    x2="35.7297"
                    y1="28.4963"
                    y2="42.3611"
                    fill="none"
                    stroke="#000000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <line
                    x1="35.7297"
                    x2="35.7297"
                    y1="48.3611"
                    y2="48.3815"
                    fill="none"
                    stroke="#000000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
            </g>
        </svg>
    );
};

export default Warning;
